module.exports = __webpack_public_path__ + "static/media/loader-footer.ea3534da.png";